import React from 'react';

const Admin = () => {
  return (
    <div className="bg-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-cyan-500">Admin Panel</h2>
          <p className="mt-4 text-gray-300">
            Please check your email for order notifications.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Admin;